import { render, staticRenderFns } from "./ResourcesSettingModal.vue?vue&type=template&id=480c84e5&scoped=true&"
import script from "./ResourcesSettingModal.vue?vue&type=script&lang=js&"
export * from "./ResourcesSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesSettingModal.vue?vue&type=style&index=0&id=480c84e5&prod&lang=scss&"
import style1 from "./ResourcesSettingModal.vue?vue&type=style&index=1&id=480c84e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c84e5",
  null
  
)

export default component.exports